var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M4.2,37.2h36.5v-1h-2.4V7.8H15v4.7H6.8v23.8H4.2V37.2z M24.8,36.3v-5.8h3.8v5.8H24.8z M16,8.7h21.4v27.6 h-7.9v-6.7h-5.6v6.7H16V8.7z M7.7,13.5H15v22.9H7.7V13.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.8,
    y: 30.5,
    fill: "#C9C9C9",
    width: 3.8,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 25.8,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 25.8,
    fill: "#F9F9F9",
    width: 1.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M16,36.2h7.9v-6.7h5.6v6.7h7.9V8.7H16V36.2z M22.7,10.8H26V14h-3.3V10.8z M27.3,10.8h3.3V14h-3.3V10.8z  M32,10.8h3.3V14H32V10.8z M35.3,32.8H32v-3.3h3.3V32.8z M21.2,32.8H18v-3.3h3.3V32.8z M22.7,18.8v-3.3H26v3.3H22.7z M27.3,18.8 v-3.3h3.3v3.3H27.3z M18,28.2v-3.3h3.3v3.3H18z M26,23.5h-3.3v-3.3H26V23.5z M21.2,20.2v3.3H18v-3.3H21.2z M30.7,23.5h-3.3v-3.3 h3.3V23.5z M21.2,15.5v3.3H18v-3.3H21.2z M22.7,28.2v-3.3H26v3.3H22.7z M27.3,24.8h3.3v3.3h-3.3V24.8z M35.3,28.2H32v-3.3h3.3V28.2 z M35.3,23.5H32v-3.3h3.3V23.5z M35.3,18.8H32v-3.3h3.3V18.8z M21.2,14H18v-3.3h3.3V14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 11.7,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16.3,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 21,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 11.7,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 11.7,
    fill: "#F9F9F9",
    width: 1.5,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 25.8,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 11.7,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 30.5,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 16.3,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 25.8,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 30.5,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 21,
    fill: "#F9F9F9",
    width: 1.5,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 16.3,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 21,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 21,
    fill: "#F9F9F9",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 16.3,
    fill: "#F9F9F9",
    width: 1.5,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 21,
    fill: "#F9F9F9",
    width: 1.5,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 16.3,
    fill: "#F9F9F9",
    width: 1.5,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 30.5,
    fill: "#F9F9F9",
    width: 1.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M15,36.3V13.5H7.7v22.9H15z M9.7,32.8v-3.3H13v3.3H9.7z M9.7,28.2v-3.3H13v3.3H9.7z M9.7,23.5v-3.3H13v3.3 H9.7z M9.7,18.8v-3.3H13v3.3H9.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 25.8,
    fill: "#F9F9F9",
    width: 1.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18,10.8V14h3.3v-3.3H18z M20.2,13h-1.4v-1.4h1.4V13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M26,10.8h-3.3V14H26V10.8z M25,13h-1.4v-1.4H25V13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.7,10.8h-3.3V14h3.3V10.8z M29.8,13h-1.5v-1.4h1.5V13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M35.3,10.8H32V14h3.3V10.8z M34.5,13H33v-1.4h1.4V13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18,18.8h3.3v-3.3H18V18.8z M18.8,16.3h1.4v1.4h-1.4V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.7,15.5v3.3H26v-3.3H22.7z M25,17.8h-1.4v-1.4H25V17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M27.3,15.5v3.3h3.3v-3.3H27.3z M29.8,17.8h-1.5v-1.4h1.5V17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32,18.8h3.3v-3.3H32V18.8z M33,16.3h1.4v1.4H33V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18,23.5h3.3v-3.3H18V23.5z M18.8,21h1.4v1.4h-1.4V21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.7,23.5H26v-3.3h-3.3V23.5z M23.5,21H25v1.4h-1.4V21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M27.3,23.5h3.3v-3.3h-3.3V23.5z M28.2,21h1.5v1.4h-1.5V21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32,23.5h3.3v-3.3H32V23.5z M33,21h1.4v1.4H33V21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21.2,28.2v-3.3H18v3.3H21.2z M18.8,27.2v-1.5h1.4v1.5H18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M26,24.8h-3.3v3.3H26V24.8z M25,27.2h-1.4v-1.5H25V27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.7,24.8h-3.3v3.3h3.3V24.8z M29.8,27.2h-1.5v-1.5h1.5V27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32,28.2h3.3v-3.3H32V28.2z M34.5,27.2H33v-1.5h1.4V27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18,29.5v3.3h3.3v-3.3H18z M20.2,32h-1.4v-1.5h1.4V32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32,29.5v3.3h3.3v-3.3H32z M34.5,32H33v-1.5h1.4V32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M13,15.5H9.7v3.3H13V15.5z M12,17.8h-1.5v-1.4H12V17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.7,20.2v3.3H13v-3.3H9.7z M12,22.5h-1.5V21H12V22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.7,24.8v3.3H13v-3.3H9.7z M12,27.2h-1.5v-1.5H12V27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M13,29.5H9.7v3.3H13V29.5z M12,32h-1.5v-1.5H12V32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.aef25480dc139691ba84e4325c24343e.svg";
export { ForwardRef as ReactComponent };